import { get, post, del, patch } from '../helpers/fetchSagaAPI';

export const getCategories = function* (payload) {
  return yield get(`/api/v2/tags/publishers/${payload.publisherId}`);
};

export const createCategory = function* (payload) {
  return yield post(`/api/v2/tags/publishers/${payload.publisherId}`, { ...payload });
};

export const updateCategory = function* (payload) {
  return yield patch(`/api/v2/tags/${payload.categoryId}/publishers/${payload.publisherId}`, { ...payload });
};

export const deleteCategory = function* (payload) {
  return yield del(`/api/v2/tags/${payload.tagId}/publishers/${payload.publisherId}/`);
};

export const getTagInformation = function* (payload) {
  return yield get(`/api/v2/tags/${payload.tagId}/publishers/${payload.publisherId}`);
};

export const setSoundcastsToTag = function* (payload) {
  return yield post(`/api/v2/tags/${payload.tagId}/soundcasts`, { ...payload });
};

export const removeSoundcastsFromTag = function* (payload) {
  return yield del(`/api/v2/tags/${payload.tagId}/soundcasts`, { data: { ...payload } });
};

export const updateTagSoundcastsOrder = function* (payload) {
  return yield post(`/api/v2/tags/publishers/${payload.publisherId}/order`, { ...payload });
};

export const setTagAsFeatured = function* (payload) {
  return yield post(`/api/v2/tags/${payload.id}/publishers/${payload.publisherId}/setfeatured`, { ...payload });
};

export const clearFeaturedTag = function* (payload) {
  return yield post(`/api/v2/tags/publishers/${payload.publisherId}/clearfeatured`, { ...payload });
};
